import React from "react";

const Icon = (props) => (
  <span
    className={props.className || ""}
    style={props.className ? {} : { display: "inline-block" }}
  >
    <img
      style={{ height: props.size, width: props.size }}
      src={require(`./icon-svg/${props.filename}.svg`)}
    />
  </span>
);

export default Icon;
